import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  location: null,
  userInfo: null,
  currentShopInfo: null,
  bankInfo: null
}

const mutations = {
  setLocationInfo(state, payload = {}) {
    state.location = payload
  },
  setUserInfo(state, payload = {}) {
	  state.userInfo = payload
  },
  setCurrentShopInfo (state, payload = {}) {
	  state.currentShopInfo = payload
  },
  setBankInfo(state, payload = {}) {
    state.bankInfo = payload
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js